/**
 * Styled accordion trigger title (“Elite Prime vs Elite”).
 * Plan names stay medium; connector (“vs”) uses muted weight.
 * Single-line titles: put the text in `leading` and leave connector/trailing empty.
 */

import type { CompareTitleParts } from '../../types/compare.types'

export function ElitePlansCompareTitle({ title }: { title: CompareTitleParts }) {
  return (
    <span className='text-base leading-[1.2] text-[#3D3D3D]'>
      <span className='font-medium'>{title.leading}</span>
      {title.connector ? (
        <>
          {' '}
          <span className='font-normal text-[#8E9393]'>{title.connector}</span>
        </>
      ) : null}
      {title.trailing ? (
        <>
          {' '}
          <span className='font-medium'>{title.trailing}</span>
        </>
      ) : null}
    </span>
  )
}
